module.exports = __webpack_public_path__ + "static/media/SystemsBlack.7109a57c.svg";